/* eslint-disable node/no-process-env */

import { UseFormProps } from "react-hook-form";

export const commonFormOptions: UseFormProps = {
  mode: "all",
  criteriaMode: "all",
  delayError: 1_000,
};
